import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f225ccc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "passenger" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "input-group" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col--12 col-sm--6 col-lg--3" }
const _hoisted_6 = { class: "col--12 col-sm--6 col-lg--3" }
const _hoisted_7 = { class: "col--12 col-sm--6 col-lg--3" }
const _hoisted_8 = { class: "col--12 col-sm--6 col-lg--3" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col--12 col-sm--6 col-lg--3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseDropdown = _resolveComponent("BaseDropdown")!
  const _component_BaseInput = _resolveComponent("BaseInput")!
  const _component_BaseDateInput = _resolveComponent("BaseDateInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", null, _toDisplayString(_ctx.passengerText), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_BaseDropdown, {
            name: 'title',
            label: 'Title',
            placeholder: 'Title',
            options: _ctx.titles,
            hasError: _ctx.v$.title.$error,
            errors: _ctx.v$.title.$errors,
            valid: !_ctx.v$.title.$invalid,
            disabled: _ctx.isLocked === true,
            modelValue: _ctx.v$.title.$model,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.title.$model) = $event))
          }, null, 8, ["options", "hasError", "errors", "valid", "disabled", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_BaseInput, {
            type: 'text',
            name: 'forename',
            label: 'Forename',
            placeholder: 'Forename',
            hasError: _ctx.v$.firstName.$error,
            errors: _ctx.v$.firstName.$errors,
            valid: !_ctx.v$.firstName.$invalid,
            disabled: _ctx.isLocked === true,
            modelValue: _ctx.v$.firstName.$model,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.firstName.$model) = $event))
          }, null, 8, ["hasError", "errors", "valid", "disabled", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_BaseInput, {
            type: 'text',
            name: 'surname',
            label: 'Surname',
            placeholder: 'Surname',
            hasError: _ctx.v$.lastName.$error,
            errors: _ctx.v$.lastName.$errors,
            valid: !_ctx.v$.lastName.$invalid,
            disabled: _ctx.isLocked === true,
            modelValue: _ctx.v$.lastName.$model,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.lastName.$model) = $event))
          }, null, 8, ["hasError", "errors", "valid", "disabled", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_BaseDateInput, {
            name: 'dateofbirth',
            label: 'Date of birth',
            hasError: _ctx.v$.dateOfBirth.$error,
            errors: _ctx.v$.dateOfBirth.$errors,
            valid: !_ctx.v$.dateOfBirth.$invalid,
            disabled: _ctx.isLocked === true,
            modelValue: _ctx.v$.dateOfBirth.$model,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.dateOfBirth.$model) = $event))
          }, null, 8, ["hasError", "errors", "valid", "disabled", "modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          (_ctx.passenger.validationRequired === true)
            ? (_openBlock(), _createBlock(_component_BaseInput, {
                key: 0,
                name: "concessionNumber",
                label: _ctx.concessionNumberLabel,
                hasError: _ctx.v$.concessionNumber.$error,
                errors: _ctx.v$.concessionNumber.$errors,
                valid: !_ctx.v$.concessionNumber.$invalid,
                modelValue: _ctx.v$.concessionNumber.$model,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.v$.concessionNumber.$model) = $event)),
                disabled: _ctx.isLocked === true
              }, null, 8, ["label", "hasError", "errors", "valid", "modelValue", "disabled"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}